import React from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import "./index.css";
import Footer from "./components/Footer";

export default function App({ isLoggedIn }) {
  const location = useLocation();
  const [isOwner, setIsOwner] = React.useState(sessionStorage.getItem("plx_owner") === "1");

  React.useEffect(() => {
    if (!isLoggedIn || isOwner) return;
    const token = localStorage.getItem("token");
    if (!token) return;
    fetch(`${process.env.REACT_APP_API}/metrics/overview`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => {
        if (r.ok) {
          sessionStorage.setItem("plx_owner", "1");
          setIsOwner(true);
        }
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);
  const pathname = location.pathname;

  const hideNavRoutes = ["/refer/splash", "/refer/login"];

  const renderNav = () => {
    if (hideNavRoutes.includes(pathname)) return null;

    if (pathname === "/refer/login") {
      return (
        <Link
          to="/refer/register"
          className="text-primary hover:underline font-medium"
        >
          Register
        </Link>
      );
    }

    if (pathname === "/refer/register") {
      return (
        <Link to="/refer/login" className="text-primary hover:underline font-medium">
          Login
        </Link>
      );
    }

    if (isLoggedIn) {
      const handleLogout = () => {
        localStorage.removeItem("token");
        window.location.href = "/refer/login";
      };

      return (
        <div className="flex items-center justify-between w-full">
          <div className="space-x-6">
            <Link
              to="/refer/dashboard"
              className="text-primary hover:underline font-medium"
            >
              Dashboard
            </Link>
            <Link
              to="/refer/radar"
              className="text-primary hover:underline font-medium"
            >
              Radar
            </Link>
            <Link
              to="/refer/practice-area"
              className="text-primary hover:underline font-medium"
            >
              Practice Area
            </Link>
            <Link
              to="/refer/outreach"
              className="text-primary hover:underline font-medium"
            >
              Outreach
            </Link>
            {isOwner && (
              <Link
                to="/refer/insights"
                className="text-primary hover:underline font-medium"
              >
                Insights
              </Link>
            )}
          </div>
          <button
            onClick={handleLogout}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded font-medium"
          >
            Logout
          </button>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="min-h-screen flex flex-col">
      {!hideNavRoutes.includes(pathname) && (
        <nav className="bg-white shadow px-6 py-4">{renderNav()}</nav>
      )}
      <main className="flex-1 px-6 py-6">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
